import type { User } from '@/types/user';

/**
 * SSO-only account: Firebase lists the user's sign-in providers and none of
 * them is `password`. When `providers` is absent (older API responses) this
 * fails safe to `false` so password-account UI keeps rendering.
 */
export function isPasswordlessAccount(user: Pick<User, 'providers'>): boolean {
  const providers = user.providers;
  return Array.isArray(providers) && providers.length > 0 && !providers.includes('password');
}
